export const timeZones = {
  pacific: 'America/Los_Angeles',
  utc: 'Etc/UTC',
}
